import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { Modal, Button } from "react-bootstrap";

const initialFieldValues = {
  name: "",
  email: "",
  phoneNumber: "",
  userName: "",
  password: "",
  roleName: "",
};

export default function Users({ onClose, headerconfig }) {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const userId = localStorage.getItem("userId");
  const [userCompanyId, setUserCompanyId] = useState("");

  const validate = () => {
    let temp = {};
    temp.name = values.name === "" ? false : true;
    temp.email = values.email === "" ? false : true;
    temp.userName = values.userName === "" ? false : true;
    temp.password = values.password === "" ? false : true;
    temp.roleName = values.roleName === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitClicked(true);
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phoneNmber", values.phoneNumber || "");
      formData.append("userName", values.userName);
      formData.append("password", values.password);
      formData.append("roleName", values.roleName);
      formData.append("companyId", userCompanyId);

      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      create: (newRecord) =>
        axios.post(config.APIACTIVATEURL + config.REGISTER, newRecord, {
          ...headerconfig,
        }),
    };
  };

  const addOrEdit = (formData) => {
    applicationAPI()
      .create(formData)
      .then(() => {
        handleSuccess("Record Created");
        setBtnSubmit(true);
        onClose();
      })
      .catch(() => {
        handleError("Error in saving data");
        setBtnSubmit(true);
      });
  };
  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };
  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";

  useEffect(() => {
    GetUserData();
  }, []);

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create User</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Role</label>
            <select
              className={"form-select" + applyErrorClass("roleName")}
              name="roleName"
              value={values.roleName}
              onChange={handleInputChange}
            >
              <option value="">Select Role</option>
              <option value="SUBADMIN">Sub Admin</option>
            </select>
            {isSubmitClicked && !errors.roleName && (
              <div className="validationerror">Please select </div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              name="name"
              value={values.name}
              onChange={handleInputChange}
              className={"form-control" + applyErrorClass("name")}
              placeholder="Please Enter Name"
            />
            {isSubmitClicked && !errors.name && (
              <div className="validationerror">Please entername</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="text"
              name="email"
              value={values.email}
              onChange={handleInputChange}
              className={"form-control" + applyErrorClass("email")}
              placeholder="Please Enter Email"
            />
            {isSubmitClicked && !errors.email && (
              <div className="validationerror">Please enter email</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label">User Name</label>
            <input
              type="text"
              name="userName"
              value={values.userName}
              onChange={handleInputChange}
              className={"form-control" + applyErrorClass("userName")}
              placeholder="Please Enter UserName"
            />
            {isSubmitClicked && !errors.userName && (
              <div className="validationerror">Please enter username</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              value={values.password}
              onChange={handleInputChange}
              className={"form-control" + applyErrorClass("password")}
              placeholder="Please Enter Password"
            />
            {isSubmitClicked && !errors.password && (
              <div className="validationerror">Please enter password</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="primary" disabled={!btnSubmit}>
            Create User
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
